import { TableHead } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import InputSelect from "../components/common/InputSelect";
import PitcherSearch from "../components/common/PitcherSearch";
import Loader from "../components/common/loader/Loader";
import { UserContext } from "../contexts/UserContext";

export default function CreateGame(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },
    mobileTabl: {
      [theme.breakpoints.down("sm")]: {
        display: "flex !important",
        flexDirection: "column",
      },
    },
    mobileTablTd: {
      [theme.breakpoints.down("sm")]: {
        width: "96% !important",
        margin: "0 auto",
      },
    },
    Width100: {
      width: "99% !important",
    },
    BtnAdd: {
      backgroundColor: "gainsboro",
      marginBottom: "5px",
      margin: "0 auto",
      display: "flex",
      height: "58px",
      "&:hover": {
        backgroundColor: "lightgray",
        cursor: "pointer",
      },
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
      [theme.breakpoints.down("sm")]: {
        width: "100% !important",
      },
    },
  }));
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);

  const [sports, setSports] = useState();
  const [idLeague, setIdLeague] = React.useState(0);
  const [visitorScore, setVisitorScore] = React.useState(0);
  const [homeScore, setHomeScore] = React.useState(0);
  const [visitorPitcher, setVisitorPitcher] = useState("");
  const [homePitcher, setHomePitcher] = React.useState("");
  const [gameStat, setGameStat] = React.useState("");
  const [graded, setGraded] = React.useState(false);
  const [gameType, setGameType] = React.useState(0);
  const [hookups, setHookUps] = React.useState(false);
  const [local, setLocal] = React.useState(true);
  const [online, setOnline] = React.useState(true);
  const [shortGame, setShortGame] = React.useState(false);
  const [eventDate, setEventDate] = React.useState("");
  const [dateChanged, setDateChanged] = React.useState(false);
  const [timeChanged, setTimeChanged] = React.useState(false);
  const [pitcherChanged, setPitcherChanged] = React.useState(0);
  const [idEvent, setIdEvent] = React.useState(0);
  const [hasChildren, setHasChildren] = React.useState(false);
  const [idTeamVisitor, setIdTeamVisitor] = React.useState(0);
  const [idTeamHome, setIdTeamHome] = React.useState(0);
  const [idBannerType, setIdBannerType] = React.useState(0);
  const [gameDateTime, setGameDateTime] = React.useState("");
  const [league, setLeague] = React.useState([]);
  const [leagueID, setLeagueID] = React.useState(0);
  const [typeID, setTypeID] = React.useState(0);
  const [type, setType] = React.useState([]);
  const [familyGame, setFamilyGame] = React.useState(0);
  const [parentGame, setParentGame] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [header, setHeader] = React.useState("");
  const [visitorNumber, setVisitorNumber] = React.useState(0);
  const [visitorTeam, setVisitorTeam] = React.useState("");
  const [homeNumber, setHomeNumber] = React.useState(0);
  const [contender, setContender] = useState(1);
  const [name, setName] = useState("");
  const [odds, setOdds] = useState("");
  const [array, setArray] = useState([]);
  const [homeTeam, setHomeTeam] = React.useState("");
  const [normalGame, setNormalGame] = React.useState(0);
  const [games, setGames] = React.useState();
  const [idSport, setIdSport] = useState(0);
  const [gameStatus, setGameStatus] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [acceptAutoChanges, setAcceptAutoChanges] = React.useState(true);
  const [isSport, setIsSport] = useState(false);
  const [inserted, setInserted] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [result, setResult] = React.useState(0);
  const [withCapsOn, setWithCapsOn] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const tournamentType = [
    { Id: 1, Description: "SINGLE WINNER" },
    { Id: 2, Description: "MULTIPLE WINNER FULL PAYOUT" },
    { Id: 3, Description: "MULTIPLE WINNERS WITH ADJUSTMENT ODDS" },
  ];
  const [tournamentID, setTournamentID] = React.useState(1);
  const [placesToPaid, setPlacesToPaid] = React.useState("");

  const handleChangeGameDateTime = (event) => {
    setGameDateTime(event.target.value);
  };
  const handleChangeFamilyGame = (event) => {
    setFamilyGame(event.target.value);
  };

  const handleChangeParentGame = (event) => {
    setParentGame(event.target.value);
  };
  const handleFindParent = (event) => {
    // TODO
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleChangeHeader = (event) => {
    setHeader(event.target.value);
  };

  const handleChangePlacesToPaid = (event) => {
    setPlacesToPaid(event.target.value);
  };

  const handleChangeVisitorNumber = (event) => {
    setVisitorNumber(event.target.value);
  };

  const handleChangeVisitorTeam = (event) => {
    setInserted(false);
    setVisitorTeam(event.target.value);
  };
  const handleChangeType = (event) => {
    setVisitorTeam(event.target.value);
  };
  const handleChangeVisitorPitcher = (event) => {
    setVisitorPitcher(event.target.value);
  };

  const handleChangeHomeNumber = (event) => {
    setHomeNumber(event.target.value);
  };

  const handleChangeHomeTeam = (event) => {
    setHomeTeam(event.target.value);
  };
  const handleChangeHomePitcher = (event) => {
    setHomePitcher(event.target.value);
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
  };
  const handleChangeContender = (event) => {
    setContender(event.target.value);
  };
  const handleChangeOdds = (event) => {
    setOdds(event.target.value);
  };
  const handleChangeNumber = (event) => {
    setVisitorNumber(event.target.value);
    setHomeNumber(event.target.value);
  };
  const setVisitorPitcherOnMem = (VisitorPitcher) => {
    setVisitorPitcher(VisitorPitcher);
  };
  const setHomePitcherOnMem = (HomePitcher) => {
    setHomePitcher(HomePitcher);
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };
  const handleOk = () => {
    InsertGame();
    setHomeNumber(parseInt(homeNumber) + 2);
    setVisitorNumber(parseInt(visitorNumber) + 2);
    setVisitorTeam("");
    setHomeTeam("");
    setDescription("");
    setHeader("");
    GetGames(leagueID, typeID);
  };

  const InsertGame = () => {
    if (
      (props.IdSport == "TNT" || props.IdSport == "MU") &&
      description == ""
    ) {
      alert("Description is required");
    } else if (leagueID != 0 && typeID != 0 && gameDateTime != "") {
      let gameRequest = {
        IdSport: props.IdSport == "" ? idSport : props.IdSport,
        IdLeague: leagueID,
        IdGameType: typeID,
        GameDateTime: gameDateTime
          ? gameDateTime.replace(" ", "T").split(".")[0]
          : "",
        VisitorNumber: props.IdSport == "TNT" ? 1 : visitorNumber,
        HomeNumber: props.IdSport == "TNT" ? 2 : homeNumber,
        VisitorTeam:
          props.IdSport == "TNT"
            ? withCapsOn
              ? description.toUpperCase()
              : description
            : withCapsOn
              ? visitorTeam.toUpperCase()
              : visitorTeam,
        HomeTeam:
          props.IdSport == "TNT"
            ? withCapsOn
              ? description.toUpperCase()
              : description
            : withCapsOn
              ? homeTeam.toUpperCase()
              : visitorTeam,
        VisitorScore: visitorScore,
        HomeScore: homeScore,
        VisitorPitcher: visitorPitcher,
        HomePitcher: homePitcher,
        NormalGame: normalGame,
        GameStat: "D",
        Graded: graded,
        Hookups: hookups,
        Local: local,
        Online: online,
        ShortGame: shortGame,
        EventDate: gameDateTime
          ? gameDateTime.replace(" ", "T").split(".")[0]
          : "",
        DateChanged: dateChanged,
        YimeChanged: timeChanged,
        PitcherChanged: pitcherChanged,
        Period: 0,
        ParentGame: parentGame,
        GradedDate: null,
        NumTeams:
          props.IdSport == "TNT" || props.IdSport == "PROP" ? array.length : 2,
        IdEvent: idEvent,
        FamilyGame: familyGame,
        HasChildren: hasChildren,
        IdTeamVisitor: idTeamVisitor,
        IdTeamHome: idTeamHome,
        IdBannerType: idBannerType,
        Description: description,
        AcceptAutoChanges: acceptAutoChanges,
        IdUser: userInfo.userId,
        Result: result,
        TournamentType: props.IdSport === "TNT" ? tournamentID : 0,
        TournamentPlacestoPaid: props.IdSport === "TNT" ? placesToPaid : 0,
      };
      setIsLoading(true);
      axios({
        method: "post",
        //url: 'https://localhost:44337/api/Game/InsertGame',
        url: process.env.REACT_APP_API2_URL + "/Game/InsertGame",
        data: gameRequest,
      }).then((response) => {
        let IdGame = response.data;
        if (props.IdSport == "TNT") {
          axios({
            method: "post",
            // url: 'https://localhost:44337/api/Game/InsertGameValuesTNT?idGame=' + IdGame,
            url:
              process.env.REACT_APP_API2_URL +
              "/Game/InsertGameValuesTNT?idGame=" +
              IdGame,
            data: array,
          }).then((response) => {
            setArray([]);
            props.searchGameValues();
          });
        } else if (props.IdSport == "PROP") {
          let propRequest = [];
          propRequest.push({ Id: visitorNumber, TeamName: name, Odds: odds });
          axios({
            method: "post",
            // url:'https://localhost:44337/api/Game/InsertGameValuesTNT?idGame=' +IdGame,
            url:
              process.env.REACT_APP_API2_URL +
              "/Game/InsertGameValuesTNT?idGame=" +
              IdGame,
            data: propRequest,
          }).then((response) => {
            setHomeTeam("");
            props.searchGameValues();
          });
        } else {
          props.searchGameValues();
        }
        setInserted(true);
        setIsLoading(false);
      });
    } else {
      alert("Date, League and Type are required");
    }
  };

  const handleArray = () => {
    let p = array.slice();
    p.push({ Id: contender, TeamName: name, Odds: odds });
    setArray(p);
    setContender(parseInt(contender) + 1);
  };

  useEffect(() => {
    // Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/GameType/GameType_Get";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setType(data);
      })
      .then(setLoading(false));
  }, [gameType]);

  useEffect(() => { }, []);

  useEffect(() => {
    if (props.IdSport != "") {
      setIsSport(true);
      GetLeagues(props.IdSport);
    } else {
      GetSports();
    }
  }, []);

  const GetSports = () => {
    const url = process.env.REACT_APP_API2_URL + "/Player/GetSports";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let groupingInfo = data.map((v) => {
          v.IdSport = v.IdSport;
          v.SportName = v.SportName;
          return v;
        });
        setSports(groupingInfo);
      });
  };

  const GetGames = (IdLeague, IdType) => {
    if (IdLeague != 0 && IdType != 0) {
      const url =
        process.env.REACT_APP_API_URL +
        "/GAME?filter=IdLeague,eq," +
        IdLeague +
        "&filter=IdGameType,eq," +
        IdType;
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setGames(data.records.filter((g) => g.GameStat != "B"));
        });
    }
  };

  const GetLeagues = (sport) => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/League/League_GetLeaguesByIdSport?idSport=" +
      sport;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        const sortedData = data.sort((a, b) => {
          if (a.leagueOrder !== b.leagueOrder) {
            return a.leagueOrder - b.leagueOrder;
          }
          return a.description.localeCompare(b.description);
        });
        setLeague(sortedData);
      })
      .then(setLoading(false));
  };

  function changeLeagueID(value) {
    setLeagueID(value);
    GetGames(value, typeID);
  }

  function changeTypeID(value) {
    setTypeID(value);
    console.log(value);
    //(leagueID, value);
  }

  function changeTournamentID(value) {
    setTournamentID(value);
    console.log(value);
  }

  function changeSportID(value) {
    setIdSport(value);

    setIsSport(true);
    GetLeagues(value);
  }

  function onAfterDeleteRow(rowKeys) {
    setArray(array.filter((item) => item.Id !== rowKeys));
  }

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
  };

  const selectRowProp = {
    mode: "checkbox",
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              New Game
            </Typography>
            <IconButton>
              <FormControlLabel
                style={{ color: "#111827" }}
                label="Insert Caps"
                control={
                  <Checkbox
                    checked={withCapsOn}
                    onChange={() => {
                      setWithCapsOn(!withCapsOn);
                    }}
                    name="InsertCaps"
                    color="secondary"
                  />
                }
              />
            </IconButton>
          </Toolbar>
        </AppBar>
        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
          <React.Fragment>
            <br />
            <form className={classes.center}>
              <Divider />
              <FormGroup row>
                <TextField
                  required
                  variant="outlined"
                  id="gameDateTime"
                  label="Game Date and Time"
                  type="datetime-local"
                  value={
                    gameDateTime
                      ? gameDateTime.replace(" ", "T").split(".")[0]
                      : ""
                  }
                  onChange={handleChangeGameDateTime}
                  className={classes.textField}
                  style={{ width: "80%" }}
                  InputLabelProps={{ shrink: true }}
                />
              </FormGroup>
              <Divider />
              {props.IdSport == "" ? (
                <FormGroup row>
                  <div style={{ float: "left" }}>
                    <InputSelect
                      size="small"
                      required
                      variant="outlined"
                      name="name"
                      fullWidth
                      data={sports}
                      placeholder="Sports"
                      setSelectValue={changeSportID}
                    />
                  </div>
                </FormGroup>
              ) : (
                ""
              )}
              <FormGroup row>
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  {isSport ? (
                    <InputSelect
                      size="small"
                      variant="outlined"
                      name="name"
                      required
                      data={league}
                      placeholder="League"
                      setSelectValue={changeLeagueID}
                      startValue={leagueID}
                    />
                  ) : (
                    ""
                  )}{" "}
                </FormControl>
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  <InputSelect
                    size="small"
                    variant="outlined"
                    name="name"
                    required
                    data={type}
                    placeholder="Type"
                    setSelectValue={changeTypeID}
                    startValue={typeID}
                  />
                </FormControl>
              </FormGroup>
              {props.IdSport === "TNT" && (
                <>
                  <Divider />
                  <FormGroup>
                    <FormControl
                      className={`${classes.formControl} w-[97%]`}
                      size="small"
                      variant="outlined"
                    >
                      <InputSelect
                        size="small"
                        variant="outlined"
                        name="name"
                        required
                        data={tournamentType}
                        placeholder="Tournament"
                        setSelectValue={changeTournamentID}
                        startValue={tournamentID}
                      />
                      <TextField
                        fullWidth
                        type="text"
                        label="Places to Paid"
                        value={placesToPaid}
                        multiline={false}
                        rows="4"
                        onChange={handleChangePlacesToPaid}
                        variant="outlined"
                        className={`${classes.mobileTablTd} ${classes.Width100}`}
                      />
                    </FormControl>
                  </FormGroup>
                </>
              )}
              {leagueID != 0 && typeID != 0 ? (
                <div style={{ position: "absolute", left: "76%", top: "11%" }}>
                  <br></br>
                  <div style={{ height: "400px", overflowY: "scroll" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <strong>
                              Games are ready in the system for this league and
                              type
                            </strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {games &&
                        games.map((row) =>
                          props.IdSport != "TNT" ? (
                            row.GameStat != "B" ? (
                              <TableRow>
                                <TableCell>
                                  {"(" +
                                    row.VisitorNumber +
                                    ")" +
                                    row.VisitorTeam}
                                </TableCell>
                                <TableCell>
                                  {"(" + row.HomeNumber + ") " + row.HomeTeam}
                                </TableCell>
                              </TableRow>
                            ) : (
                              ""
                            )
                          ) : row.GameStat != "B" ? (
                            <TableRow>
                              <TableCell>
                                {row.Description + row.VisitorTeam}
                              </TableCell>
                            </TableRow>
                          ) : (
                            ""
                          )
                        )}
                    </Table>
                  </div>
                </div>
              ) : (
                ""
              )}
              <Divider />
              <FormGroup row>
                <TextField
                  type="number"
                  label="Parent Game"
                  value={parentGame}
                  multiline={false}
                  onChange={handleChangeParentGame}
                  variant="outlined"
                />
                <Button
                  disabled
                  className={classes.button}
                  variant="contained"
                  onClick={handleFindParent}
                  startIcon={<SearchIcon />}
                >
                  Find
                </Button>
              </FormGroup>
              <Divider />
              <FormGroup row>
                <TextField
                  type="number"
                  label="Family Game"
                  value={familyGame}
                  multiline={false}
                  onChange={handleChangeFamilyGame}
                  variant="outlined"
                />

                <Button
                  className={classes.button}
                  disabled
                  variant="contained"
                  onClick={handleFindParent}
                  startIcon={<SearchIcon />}
                >
                  Find
                </Button>
              </FormGroup>
              <Divider />
              <FormGroup row className={classes.mobileTabl}>
                <TextField
                  fullWidth
                  type="text"
                  label="Description"
                  value={description}
                  multiline={false}
                  rows="4"
                  onChange={handleChangeDescription}
                  variant="outlined"
                  className={classes.mobileTablTd}
                  InputLabelProps={{ shrink: true }}
                />
                {/* {props.IdSport === "TNT" && (
                  <TextField
                    fullWidth
                    type="text"
                    label="Header"
                    value={header}
                    multiline={false}
                    rows="4"
                    onChange={handleChangeHeader}
                    variant="outlined"
                    className={classes.mobileTablTd}
                  />
                )} */}
              </FormGroup>
              <Divider />{" "}
              {props.IdSport == "TNT" || props.IdSport == "PROP" ? (
                <React.Fragment>
                  {" "}
                  {props.IdSport == "TNT" ? (
                    <FormGroup column>
                      <Table>
                        <TableRow className={classes.mobileTabl}>
                          <TableCell className={classes.mobileTablTd}>
                            <TextField
                              variant="outlined"
                              type="number"
                              label="Contenders #"
                              value={contender}
                              multiline={false}
                              onChange={handleChangeContender}
                              className={classes.mobileTablTd}
                            />
                          </TableCell>
                          <TableCell className={classes.mobileTablTd}>
                            <TextField
                              variant="outlined"
                              type="text"
                              label="Name"
                              value={name}
                              multiline={false}
                              onChange={handleChangeName}
                              className={classes.mobileTablTd}
                            />
                          </TableCell>
                          <TableCell className={classes.mobileTablTd}>
                            <TextField
                              variant="outlined"
                              type="number"
                              label="Odds"
                              value={odds}
                              multiline={false}
                              onChange={handleChangeOdds}
                              className={classes.mobileTablTd}
                            />
                          </TableCell>
                          <TableCell className={classes.mobileTablTd}>
                            <Button
                              color="inherit"
                              onClick={handleArray}
                              className={`${classes.mobileTablTd} ${classes.BtnAdd}`}
                            >
                              Add
                            </Button>
                          </TableCell>
                        </TableRow>
                      </Table>
                      <Table>
                        <TableRow>
                          <BootstrapTable
                            data={array}
                            selectRow={selectRowProp}
                            options={options}
                          >
                            <TableHeaderColumn isKey={true} dataField="Id">
                              ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="TeamName">
                              Name
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="Odds">
                              Odds
                            </TableHeaderColumn>
                          </BootstrapTable>
                        </TableRow>
                      </Table>
                    </FormGroup>
                  ) : (
                    <FormGroup row>
                      <Table>
                        <TableRow>
                          <TableCell>
                            <TextField
                              variant="outlined"
                              type="number"
                              label="Number"
                              value={visitorNumber}
                              multiline={true}
                              onChange={handleChangeNumber}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              variant="outlined"
                              type="text"
                              label="Type"
                              value={visitorTeam}
                              multiline={true}
                              onChange={handleChangeType}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              variant="outlined"
                              type="text"
                              label="Participant"
                              value={homeTeam}
                              multiline={true}
                              onChange={handleChangeHomeTeam}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              variant="outlined"
                              type="number"
                              label="Odds"
                              value={odds}
                              multiline={true}
                              onChange={handleChangeOdds}
                            />
                          </TableCell>
                        </TableRow>
                      </Table>
                    </FormGroup>
                  )}{" "}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <FormGroup row className="gap-4">
                    <FormControl
                      className={`${classes.formControl} w-full`}
                      size="small"
                      variant="outlined"
                    >
                      <TextField
                        type="number"
                        label="Visitor Team #"
                        value={visitorNumber}
                        multiline={true}
                        onChange={handleChangeVisitorNumber}
                        variant="outlined"
                      />
                    </FormControl>
                    <FormControl
                      className={`${classes.formControl} w-full`}
                      size="small"
                      variant="outlined"
                    >
                      <TextField
                        variant="outlined"
                        type="text"
                        label="Visitor Team"
                        required
                        value={visitorTeam}
                        multiline={true}
                        onChange={handleChangeVisitorTeam}
                      />
                    </FormControl>

                    {props.IdSport == "MLB" ? (
                      <FormControl
                        className={`${classes.formControl} w-full`}
                        size="small"
                        variant="outlined"
                      >
                        <PitcherSearch
                          isInput={true}
                          initialValue={visitorPitcher}
                          setPitcherOnMem={setVisitorPitcherOnMem}
                        ></PitcherSearch>
                      </FormControl>
                    ) : null}
                  </FormGroup>
                  <FormGroup row className="gap-4">
                    <FormControl
                      className={`${classes.formControl} w-full`}
                      size="small"
                      variant="outlined"
                    >
                      <TextField
                        variant="outlined"
                        type="number"
                        label="Home Team #"
                        value={homeNumber}
                        multiline={true}
                        onChange={handleChangeHomeNumber}
                      />
                    </FormControl>
                    <FormControl
                      className={`${classes.formControl} w-full`}
                      size="small"
                      variant="outlined"
                    >
                      <TextField
                        variant="outlined"
                        type="text"
                        label="Home Team"
                        value={homeTeam}
                        multiline={true}
                        onChange={handleChangeHomeTeam}
                      />
                    </FormControl>

                    {props.IdSport == "MLB" ? (
                      <FormControl
                        className={`${classes.formControl} w-full`}
                        size="small"
                        variant="outlined"
                      >
                        <PitcherSearch
                          isInput={true}
                          initialValue={homePitcher}
                          setPitcherOnMem={setHomePitcherOnMem}
                        ></PitcherSearch>
                      </FormControl>
                    ) : null}
                  </FormGroup>
                  {inserted ? (
                    <FormGroup row>
                      <FormControl
                        className={`${classes.formControl} w-full`}
                        size="small"
                        variant="outlined"
                      >
                        <InputBase
                          style={{
                            color: "red",
                            fontSize: 35,
                            fontWeight: "bold",
                          }}
                          className={classes.margin}
                          defaultValue="Done!"
                          inputProps={{ "aria-label": "naked" }}
                        />
                      </FormControl>
                    </FormGroup>
                  ) : (
                    ""
                  )}{" "}
                </React.Fragment>
              )}{" "}
            </form>
          </React.Fragment>
        )}

        <React.Fragment>
          <DialogActions>
            {isLoading ? (
              <Loader height={100} width={100}></Loader>
            ) : (
              <div>
                <Button
                  color="inherit"
                  startIcon={<CancelIcon />}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  startIcon={<SaveIcon />}
                  variant="contained"
                  color="primary"
                  onClick={handleOk}
                >
                  Ok
                </Button>
              </div>
            )}
          </DialogActions>
        </React.Fragment>
      </Dialog>
    </React.Fragment>
  );
}
